import { tableSortFilter } from '@/utils/arrayProcessing';
import type { AuthSession } from '@/features/users/shared/types';

export const USER_SESSIONS_TABLE_HEAD = [
  { id: 'emptyCell' },
  { id: 'label', label: 'Device', align: 'left', minWidth: 260 },
  { id: 'ipAddress', label: 'IP address', align: 'left', minWidth: 120 },
  { id: 'loginSource', label: 'Login source', align: 'left', minWidth: 140 },
  { id: 'createdAt', label: 'Created', align: 'left', minWidth: 160 },
  { id: 'lastSeenAt', label: 'Last seen', align: 'left', minWidth: 160 },
  { id: 'expiresAt', label: 'Expires', align: 'left', minWidth: 160 },
  { id: 'current', label: 'Status', align: 'left', minWidth: 100 },
  { id: 'actionButtons', label: '', align: 'right', width: 56 },
];

export function applySortFilterUserSessions({
  tableData,
  comparator,
  searchFieldValue,
}: {
  tableData: AuthSession[];
  comparator: (a: AuthSession, b: AuthSession) => number;
  searchFieldValue: string;
}) {
  let filteredData = tableSortFilter(tableData, comparator);
  const searchFieldLowerCase = searchFieldValue.toLowerCase().trim();

  if (!searchFieldLowerCase) {
    return filteredData;
  }

  filteredData = filteredData.filter((session) =>
    [
      session.label,
      session.deviceName,
      session.deviceId,
      session.browser,
      session.os,
      session.deviceType,
      session.ipAddress,
      session.loginSource,
      session.userAgent,
      session.sessionId,
    ]
      .filter(Boolean)
      .some((value) =>
        String(value).toLowerCase().includes(searchFieldLowerCase)
      )
  );

  return filteredData;
}
